import React, {useContext } from 'react'
import { translate, I18n } from "react-i18nify";
import { langContext } from "../../context/langContext"
import "./styles.scss"

export const SelectorLanguge = ({ lang }) => {

    const idioma = useContext(langContext);

    const options = [
      {
        value: "es",
        label: <I18n render={() => <span>{translate("menu.spanish")}</span>} />
      },
    
      {
        value: "en",
        label: <I18n render={() => <span>{translate("menu.english")}</span>} />
      },
      {
        value: "pt",
        label: <I18n render={() => <span>{translate("menu.portuguese")}</span>} />
      }
    ]

    const idiomageneral =()=>{
      if(idioma.locale === "en"){
       return <I18n render={() => <span>{translate("menu.english")}</span>} />
      }else if(idioma.locale === "pt"){
       return <I18n render={() => <span>{translate("menu.portuguese")}</span>} />
      }else
      return <I18n render={() => <span>{translate("menu.spanish")}</span>} />
    }

  return (
    <div className="DropDownContainer">
    <div className="DropDownHeader" onClick={() => idioma.toggling()}>
      <i className="fa fa-globe" aria-hidden="true" style={{ paddingRight: "0.3em" }}></i>
      {idioma.selectedOption || idiomageneral()}
      <i className="fa fa-angle-down" aria-hidden="true" style={{ paddingLeft: "0.3em" }}></i></div>
    {idioma.isOpen && (
    <div className="DropDownListContainer">
      <ul className="DropDownList">
        {options.map((option,index) =>(
          <li className={`ListItem ${option === idioma.selectedOption ? 'active':''}`} onClick={()=>idioma.establecerLenguaje(option.value)} key={index}><span>{option.label}</span></li>
        ))}
      </ul>
    </div>
        )}
  </div>
  )
}
